module.exports = __webpack_public_path__ + "static/media/map-lost.3e6078f4.jpg";